import React from 'react';
import { Translate } from '@pegasus/translation';
import { Text, Preset } from '@lux/text';
import { SeeAllCardCarouselItem } from './styles';

interface SeeAllCardProps {
    onClick?: () => void;
    href?: string;
}

export const SeeAllCard: React.FC<SeeAllCardProps> = ({ onClick, href }) => {
    const handleClick = (event: React.SyntheticEvent) => {
        event.stopPropagation();
        onClick?.();
    };

    return (
        <SeeAllCardCarouselItem onClick={handleClick} as={href ? 'a' : 'button'} href={href}>
            <Text preset={Preset.M} bold underline>
                <Translate message="discoverMore" />
            </Text>
        </SeeAllCardCarouselItem>
    );
};
